<div class="grid">
  <div class="col-12">
    <div class="p-fluid">
      <label for="">{{ "COMMON.METADATA.NAME" | translate }}</label>
      <input pInputText class="p-inputtext-sm" [(ngModel)]="metadata.name" />
    </div>
  </div>
  <div class="col-12">
    <div class="p-field mb-4">
      <button
        pButton
        label="{{ 'COMMON.SAVE' | translate }}"
        (click)="this.save()"
        icon="fas fa-save"
        class="virtualcenter-button virtualcenter-button--primary"
      ></button>
    </div>
  </div>
</div>
